/* global MktoForms2 $ */

/* Marketo Form section */
/* TODO auto-fill */

MktoForms2.whenRendered(function (form) {
	var $form = form.getFormElem();
	/*
	 * if click "unsubscribe" checkbox, uncheck all other checkboxes
	 */
	$form.find("input[name=Unsubscribed]").change(function () {
		if ($(this).prop("checked")) {
			// Uncheck all other checkboxes and remove 'checked' class from their labels
			$form.find("[type=checkbox]").not("input[name=Unsubscribed]").each(function () {
				$(this).prop("checked", false);
				$(this).parent("label").removeClass("checked");
			});
		}
	});

	/*
	 * if click any checkbox other than "unsubscribe", uncheck "subscribe" checkbox
	 */

	$form.find("input[type=checkbox]").not("input[name=Unsubscribed]").change(function () {
		if ($(this).prop("checked")) {
			// Uncheck the "unsubscribe" checkbox and remove its 'checked' class
			$form.find("input[name=Unsubscribed]").prop("checked", false);
			$form.find("input[name=Unsubscribed]").parent("label").removeClass("checked");
		}
	});

	// 3. If the "Opt_out_-_News_Events_Product_Announcements" checkbox is clicked
	$form.find("input[name=Opt_out_-_News_Events_Product_Announcements]").change(function () {
		if ($(this).prop("checked")) {
			// If checked, check all other checkboxes except "unsubscribe" and "Opt_out_-_News_Events_Product_Announcements"
			$form.find("[type=checkbox]").not("input[name=Opt_out_-_News_Events_Product_Announcements], input[name=Unsubscribed]").each(function () {
				$(this).prop("checked", true);
				$(this).parent("label").addClass("checked");
			});

			// Uncheck "Unsubscribed" checkbox and remove its 'checked' class
			$form.find("input[name=Unsubscribed]").prop("checked", false);
			$form.find("input[name=Unsubscribed]").parent("label").removeClass("checked");
		} 
		else {
			// If unchecked, uncheck all checkboxes and remove 'checked' class from all labels
			$form.find("[type=checkbox]").not("input[name=Opt_out_-_News_Events_Product_Announcements]").each(function () {
				$(this).prop("checked", false);
				$(this).parent("label").removeClass("checked");
			});

			// Ensure "Unsubscribed" checkbox remains unchecked and its label has no 'checked' class
			$form.find("input[name=Unsubscribed]").prop("checked", false);
			$form.find("input[name=Unsubscribed]").parent("label").removeClass("checked");
		}
	});

	$form.find("input[name=optInCloudSecurity], input[name=optInVMDR], input[name=optInRiskManagement], input[name=optInNotifications], input[name=optInBlog]").change(function () {
        // If any of these checkboxes are unchecked
        if (!$(this).prop("checked")) {
            // Uncheck "Opt_out_-_News_Events_Product_Announcements" if any one of them is unchecked
            $form.find("input[name=Opt_out_-_News_Events_Product_Announcements]").prop("checked", false);
            $form.find("input[name=Opt_out_-_News_Events_Product_Announcements]").parent("label").removeClass("checked");
        }
    });

	// get email address from URL parameters, prefill email field and check unsubscribe checkbox
	var matches = window.location.search.match(/email=([^&]*)/);
	if (matches !== null && matches[1].indexOf("lead.Email") === -1) {
		$form.find("input[name=Email]").val(matches[1]);
		$form.find("input[name=Unsubscribed]").prop("checked", true);
	}

});
